export default {
    title: 'Курьеры',
    addCourier: 'Курьер',
    table: {
        columns: {
            name: 'ФИО',
            phoneNumber: 'Мобильный номер',
            email: 'Электронная почта',
        },
        tooltips: {
            notVerified: 'Курьер еще не подтвержден системой',
            resetPassword: 'Сменить пароль',
        },
    },
    form: {
        title: 'Новый курьер',
        fields: {
            firstName: {
                label: 'Имя',
                placeholder: 'Иван',
            },
            middleName: {
                label: 'Фамилия',
                placeholder: 'Иванов',
            },
            familyName: {
                label: 'Отчество',
                placeholder: 'Иванович',
            },
            email: {
                label: 'E-mail',
                placeholder: 'example@mail.ru',
            },
            phoneNumber: {
                label: 'Телефон',
            },
            password: {
                label: 'Пароль',
            },
        },
        require: 'Поле обязательно для заполнения',
        submitButton: 'Добавить',
        messages: {
            success: 'Курьер создан',
        },
    },
    resetPasswordForm: {
        title: 'Новый пароль',
        hint:
            'Пароль показан открыто намеренно: его надо передать курьеру. ' +
            'После сохранения посмотреть его будет негде.',
        generate: 'Сгенерировать',
        submitButton: 'Сохранить',
        fields: {
            password: {
                label: 'Пароль',
            },
        },
        validation: {
            require: 'Поле обязательно для заполнения',
            length: 'От 8 до 64 символов',
            pattern: 'Нужны и латинские буквы, и цифры',
        },
        messages: {
            success: 'Пароль курьера обновлён',
        },
    },
};
